import React from 'react';
import AbsoluteFooter from '../../components/Footer/AbsoluteFooter';
import { BsShieldExclamation } from "react-icons/bs";

function Blocked() {

    return (
        <>
            <div className="w-[100vw] h-[100vh] relative flex items-center justify-center">
                <div className="absolute top-0 flex justify-center p-5">
                    <img src="/assets/images/logo/dodeal-white.png" alt="DoDeal Properties" width="100" className="w-[100px]" />
                </div>
                {/* <div className="fixed top-50 start-50 translate-middle w-full">
                    <div className="flex justify-center p-5">
                        <BsShieldExclamation
                            size={150}
                            style={{
                                zIndex: -2,
                                color: "rgba(var(--primary-rgb), 0.1)"
                            }}
                        />
                    </div>
                </div> */}
                <div className="flex flex-col justify-center items-center text-center p-5">
                    <BsShieldExclamation
                        size={150}
                        style={{
                            zIndex: -2,
                            color: "rgba(var(--primary-rgb), 0.5)"
                        }}
                    />
                    <h1 className="text-center mt-5">
                        Some suspicious activities have been detected from your device! Please contact
                        <a href="tel:+97142621133" className="primary-text px-2">+97142621133</a>
                        for further assistance!
                    </h1>
                </div>
                <AbsoluteFooter />
            </div>
        </>
    );
}

export default Blocked;
